import * as Yup from "yup";

export const campaignWizardSchema = Yup.object({
  campaign_name: Yup.string()
    .required("Campaign name is required")
    .min(2, "Campaign name must be at least 2 characters")
    .max(100, "Campaign name must be less than 100 characters"),
  description: Yup.string().max(500, "Description must be less than 500 characters"),
  language: Yup.string().required("Language is required"),
  voice_gender: Yup.string(),
  voice_character_id: Yup.string().when("bot_type", {
    is: (val) => val === "call" || val === "CALL" || val === true,

    then: (schema) => schema.required("Select Voice Character"),
    otherwise: (schema) => schema,
  }),

  initial_message: Yup.string()
    .required("Initial message is required")
    .min(10, "Initial message must be at least 10 characters"),

  call_flow_script: Yup.string()
    .required("Call flow script is required")
    .min(20, "Call flow script must be at least 20 characters"),

  timeout: Yup.number()
    .required("Timeout is required")
    .min(10, "Timeout must be at least 10 seconds")
    .max(300, "Timeout must be less than 300 seconds"),

  ai_model: Yup.string(),
  start_hour: Yup.string(),
  start_minute: Yup.string(),
  start_am_pm: Yup.string(),
  end_hour: Yup.string(),
  end_minute: Yup.string(),
  end_am_pm: Yup.string(),
});

